import { transparentize } from 'polished'
import { StyleFn } from '..'

export const AnchorNav: StyleFn = (theme) => {
  const { color, font, size } = theme
  const defaultTextColor = color.type === 'light' ? color.palette.coolgrey[90] : color.palette.white

  // FIX: background primary color is mixed up here
  return {
    root: {
      height: '100%',
      overflowY: 'auto',
      maxWidth: size.spacing[128],
      display: 'flex',
      flexDirection: 'column',
      backgroundColor: color.getModalValues(color.background.primary),
      color: defaultTextColor,
    },
    title: {
      color: color.type === 'light' ? color.palette.coolgrey[90] : color.palette.white,
      fontSize: font.size.small,
      fontWeight: font.weight.medium,
    },
    list: {
      color: defaultTextColor,
      fontSize: font.size.small,
      fontWeight: font.weight.regular,
      listStyle: 'none',
      paddingLeft: 0,
    },
    item: {
      display: 'flex',
      position: 'relative',
      lineHeight: size.spacing[16],
      borderLeft: `2px solid ${
        color.type === 'light' ? color.palette.warmgrey['20'] : transparentize(0.84, color.palette.white)
      }`,
      '&:first-child': {
        '& $itemLink': { paddingTop: size.spacing[4] },
        '&:before': { top: 0 },
      },
      '&:last-child': {
        '& $itemLink': { paddingBottom: size.spacing[4] },
        '&:before': { bottom: 0 },
      },
      '&:before': {
        position: 'absolute',
        content: "''",
        width: size.spacing[2],
        top: size.spacing[8],
        bottom: size.spacing[8],
        left: '-' + size.spacing[2],
        backgroundColor: 'transparent',
      },
    },
    item_selected: {
      fontWeight: font.weight.regular,
      '& $itemLink': {
        color: color.type === 'light' ? color.palette.primaryblue[80] : color.palette.coolgrey[30],
      },
      '&$item:before': {
        left: -2,
        backgroundColor: color.type === 'light' ? color.palette.primaryblue[60] : color.palette.white,
      },
    },
    item_disabled: {
      cursor: 'not-allowed',
      '& $itemLink': {
        color: color.type === 'light' ? color.palette.primaryblue[20] : transparentize(0.6, color.palette.white), //pallette brand lightest
        cursor: 'not-allowed',
        pointerEvents: 'none',
      },
    },
    itemLink: {
      textDecoration: 'none',
      padding: `${size.spacing[12]} ${size.spacing[16]}`,
      paddingRight: size.spacing[8],
      color: color.type === 'light' ? color.palette.primaryblue[60] : color.palette.white,
      '&:hover:not([disabled])': {
        color: color.type === 'light' ? color.palette.primaryblue[70] : color.palette.coolgrey[20],
      },
    },
  }
}
